/**
 * Extracts a human-readable error message from an API error.
 *
 * The backend surfaces failures in a few shapes depending on the route:
 *  - a plain string body (generic errors from endpointWrapper)
 *  - `{ message: string }` (typed errors: BadRequestError, UnauthorizedError, ...)
 *  - `{ fieldErrors: { [field]: { message } } }` (validation errors)
 *
 * Always returns a string so it can be safely rendered as a React child
 * (rendering the raw response object throws "Objects are not valid as a React child").
 */
export const getErrorMessage = (
	err: any,
	fallback = 'Something went wrong.'
): string => {
	const data = err?.response?.data;

	if (typeof data === 'string' && data.trim()) {
		return data.trim();
	}

	if (typeof data?.message === 'string' && data.message.trim()) {
		return data.message.trim();
	}

	if (data?.fieldErrors && typeof data.fieldErrors === 'object') {
		const firstFieldError: any = Object.values(data.fieldErrors)[0];
		if (typeof firstFieldError?.message === 'string' && firstFieldError.message.trim()) {
			return firstFieldError.message.trim();
		}
	}

	return fallback;
};
